import { createContext, PropsWithChildren, useReducer } from "react";

interface AppContextType {
	isWelcomeDone: boolean,
	hasContributions: boolean,
	footerContribution: number,
	errorMessage: string,
	clientId: string,
	dispatchConfig?: any,
}

type ReducerType = (state: any, value: any) => any;

const defaultContextValue : AppContextType = {
	isWelcomeDone: true,
	hasContributions: true,
	footerContribution: 0,
	errorMessage: '',
	clientId: ''
};

export const AppContext = createContext(defaultContextValue);

function reducer(state: AppContextType, action: { payload: {} }) {
	return { ...state, ...action.payload };
}

export const AppProvider = (props: PropsWithChildren<{}>) => {
	const [config, dispatchConfig] = useReducer<ReducerType>(reducer, defaultContextValue);

	return (
		<AppContext.Provider value={{ ...config, dispatchConfig }}>
			{props.children}
		</AppContext.Provider>
	)
}
